import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavbarKujipy, NavbarInner, NavbarLogoStyle, NavbarElementsStyle, NavbarRight, NavbarLang, MobileActions, HamburgerButton, MobileMenu } from "./Navbar.styled";
import NavbarElement from "../NavbarElement/NavbarElement";
import NavbarLogo from "../NavbarLogo/NavbarLogo";
import AmbientAudio from "../AmbientAudio/AmbientAudio";

const links = [
  ["navbar.home", "/"], ["navbar.music", "/music"], ["navbar.culture", "/culture"],
  ["navbar.history", "/history"], ["navbar.territory", "/tlahuitoltepec"],
  ["navbar.gallery", "/gallery"], ["navbar.epk", "/epk"], ["navbar.hiring", "/hiring"]
];

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => { document.documentElement.lang = i18n.language.startsWith("en") ? "en" : "es"; }, [i18n.language]);
  useEffect(() => {
    const close = (event: KeyboardEvent) => event.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", close);
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.removeEventListener("keydown", close); document.body.style.overflow = ""; };
  }, [open]);

  const changeLanguage = (code: string) => { localStorage.setItem("kujipy-language", code); i18n.changeLanguage(code); };
  const language = (code: string) => (
    <button type="button" className={i18n.language.startsWith(code) ? "active" : ""}
      aria-pressed={i18n.language.startsWith(code)} onClick={() => changeLanguage(code)}>{code.toUpperCase()}</button>
  );
  const navLinks = links.map(([key, link]) => <NavbarElement key={link} texto={t(key)} link={link} />);
  const gameLink = <a className="game-nav-link" href="/game/">{t("navbar.game")}</a>;

  return <NavbarKujipy aria-label={t("common.navigation")}>
    <NavbarInner>
      <NavbarLogoStyle><NavbarLogo /></NavbarLogoStyle>
      <NavbarElementsStyle>{navLinks}{gameLink}</NavbarElementsStyle>
      <NavbarRight><AmbientAudio /><NavbarLang>{language("es")}{language("en")}</NavbarLang></NavbarRight>
      <MobileActions><AmbientAudio /><HamburgerButton type="button" aria-label={open ? t("common.closeMenu") : t("common.openMenu")} aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen(!open)}>{open ? "×" : "☰"}</HamburgerButton></MobileActions>
    </NavbarInner>
    <MobileMenu id="mobile-menu" $open={open} aria-hidden={!open}>{navLinks}{gameLink}<div className="mobile-lang">{language("es")}{language("en")}</div></MobileMenu>
  </NavbarKujipy>;
};

export default Navbar;
